import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c06a3b5"
import script from "./details.js?vue&type=script&lang=js&external"
export * from "./details.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports